import React, {Fragment, useState, useEffect} from "react";
import useModalAddUserConnection from "root/Modals/AddUserConnection/useModalAddUserConnection";
import {
    getUserConnections2,
    getUserDetails,
    removeConnectionInBothDirections,
    unblockUser
} from "root/DataFunctions/UserDataFns";
import {countNumberOfEditors} from "root/DataFunctions/ChildDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import ActionButton from "root/Wieldy/ApplicationModules/Common/Components/ActionButton";
// import bootbox from "bootbox";
import {useSetRecoilState} from "recoil";
import {childNameAtom} from "root/recoil/childName";
import {useParams} from "react-router";
import {UserTypes} from "root/DataFunctions/Constants";
import ConnectionsContainer from "root/Components/ConnectionContainer/ConnectionsContainer";

const ConnectionsTab = (props) =>
{
    let { user_id, child_uid, team_id } = useParams();
    team_id = team_id === undefined ? null : team_id;

    const setChildName = useSetRecoilState(childNameAtom);
    const [data, setData] = useState({isLoading: true, data: [], user_type: null, user_id: null});
    const [userIdRaw, setUserIdRaw] = useState({isLoading: true, userIdRaw: null, });

    const [renderAddUserConnectionModal, showAddUserConnectionModal] = useModalAddUserConnection((result) =>
    {
        if (result === 'saved')
        {
            getData();
        }
    })

    useEffect(() => {
        getData();
    }, [child_uid, user_id]);

    const getData = () =>
    {
        user_id = child_uid !== undefined ? child_uid : user_id;

        getUserDetails( user_id, null,(response) =>
        {
            const user = getDataFromResponse(response)[0] ;
            const userType = +(user.type_id) ;
            setUserIdRaw(user.idusers);

            getUserConnections2(user_id, (conResponse) =>
            {
                setData({isLoading: false, data: getDataFromResponse(conResponse), user_type: userType, user_id: user_id });
            });

            setChildName(user.firstname + " " + user.surname);
        })
    };

    const removeConnection = (ur_id_0, ur_id_1, row) =>
    {
        const current_user_id = child_uid === undefined ? user_id : child_uid;

        //We must check if the child still has an editor
        getUserConnections2(current_user_id, (conResponse) =>
        {
            setData({isLoading: false, data: getDataFromResponse(conResponse), user_type: UserTypes.CHILD, user_id: user_id });
            const connectionRecs = getDataFromResponse(conResponse);
            const numberOfEditors = countNumberOfEditors(connectionRecs);

            if(row.editor !== undefined && numberOfEditors === 1){
                bootbox.alert({
                    size: "large",
                    title: "Error",
                    message: "You are attempting to remove this child's only editor. You need to add another editor before removing this one.",
                    callback: function ()
                    {
                        //
                    }
                })
            }
            else
            {
                bootbox.confirm({
                    size: "large",
                    message: "This action will remove the connection and all roles between these users in both directions. Are you sure you want to do this?",
                    callback: (result =>
                    {
                        if (result)
                        {
                            removeConnectionInBothDirections(ur_id_0, ur_id_1, (response) =>
                            {
                                getData();
                            });
                        }
                    })
                })
            }
        });
    }

    const doUnblock = (user_id, blocked_by) =>
    {
        unblockUser(user_id, blocked_by);
    }

    const clickHandler = ( mode, row0, row1 ) =>
    {
        const viewing_user_id = child_uid === undefined ? user_id : child_uid;

            switch ( mode)
        {
            case 'delete' :
                removeConnection(row0.ur_id, row1.ur_id, row0);
                break;

            case 'edit' :
                showAddUserConnectionModal(mode, row0.ur_relation_idusers, row0.ur_idusers, row0.ur_idusers_raw, team_id);
                break;

            case 'create' :
                showAddUserConnectionModal(mode, viewing_user_id, null, null, team_id);
                break;

            case 'unblock' :
                  bootbox.confirm({
                    size: "small",
                      message: "Are you sure you want to un-block this user? You must be sure the user who blocked them is ok with this. " +
                          "<span style='color: red;'>You will also need to re-instate the connection between the two users.</span>",
                    callback: (result =>
                    {
                        if (result)
                        {
                            const blocked_by = row0.ur_relation_idusers;
                            const blocked_user_id = row0.ur_idusers;
                            doUnblock(blocked_user_id, blocked_by );
                        }
                    })
                })
                break;
        }
    }

    return (
        <Fragment>
            <div className="connection-body">
                { data.isLoading === false && <ConnectionsContainer loading={data.isLoading} data={data.data} userId={userIdRaw} clickHandler={clickHandler}/> }
                <section>
                    <ActionButton icon='icon-add' onClick={() => clickHandler('create', null)} title="Make new connection"/>
                </section>
            </div>

            {renderAddUserConnectionModal(props)}
        </Fragment>
    )
}

ConnectionsTab.defaultProps = {};

export default ConnectionsTab;

